// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2HsVt","right":"styles_right__1ixHD"};